<template>
  <div>
    <sidebar-header>Filter</sidebar-header>
    <sidebar-list>
      <slot />
    </sidebar-list>
  </div>
</template>

<script>
import SidebarHeader from 'src/shared/components/SidebarHeader'
import SidebarList from 'src/shared/components/SidebarList'

export default {
  name: 'SidebarFilter',
  inject: ['browseLicenses'],
  components: {
    SidebarHeader,
    SidebarList
  },
  computed: {
    isLoading() {
      return this.browseLicenses.isLoadingLicenses
    }
  }
}
</script>

<style></style>
